module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldVisible),
      expression: "fieldVisible"
    }],
    class: {
      'w5-field': _vm.isVisibleRow && _vm.Field._field_name !== 'role_items',
        'padding-for-submit-button': _vm.needButtonSubmit === true,
        'removeRightPadding': _vm.removeRightPadding,
        'removeAllPadding': _vm.Field.type === 'passport' || _vm.Field.type === 'address',
        'w5-disabled-field': _vm.Field.readonly === true,
        'w5-vds-plan': _vm.isUniqueInVds() || _vm.isUniqueInOperation() || _vm.isUniqueInCertificate(),
        'w5-filed-with-top-hint': _vm.topHint,
        'w5-filed-with-bottom-hint': _vm.bottomHint,
        'w5-fake-field': _vm.Field.type === 'fake',
        'w5-combo-list': _vm.crud === 'domains' && _vm.Field['_field_name'] === 'person_id',
        'w5-field-greyed': _vm.isFieldGreyed,
        'with-awesome-button': _vm.fontawesomeButton,
        'with-big-button': (_vm.Field.type != 'text' && _vm.Field.type != 'boolean') && _vm.bigButton,
        'header': _vm.Field.type === 'header',
        'clear-text': _vm.Field.type === 'clearText',
        'w5-iso-download-field': _vm.crud === 'iso' && (_vm.Field['_field_name'] === 'download' || _vm.Field['_field_name'] === 'library'),
        'w5-autoprolong-field': _vm.crud === 'disks' && _vm.Field['_field_name'] === 'autoprolong',
        'w5-with-info-link': _vm.linkHint && _vm.linkHint.showIfField === _vm.Field._field_name && _vm.Field.type !== 'list',
        'w5-input-with-number-divider': (_vm.crud === 'dns' && _vm.Field._field_name !== 'fastSearch' && (_vm.Field.type === 'text' || _vm.Field.type === 'money' || _vm.Field.type === 'integer' || _vm.Field.type === 'float' || _vm.Field._field_name === 'account_id')) ||
        ((_vm.crud === 'vds' || _vm.crud === 'disks' || _vm.crud === 'iso') && _vm.Field._field_name === 'account_id')
    }
  }, [(_vm.isFieldGreyed) ? _c('div', {
    staticClass: "w5-field-greyed-back"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "data-input-type": _vm.Field.type
    }
  }), _vm._v(" "), (_vm.topHint) ? _c('div', {
    staticClass: "w5-field-top-hint"
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.topHint)),
      expression: "localeFtc(topHint)"
    }]
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldPlaceholderVisible),
      expression: "fieldPlaceholderVisible"
    }],
    staticClass: "w5-field-placeholder",
    class: {
      'active': _vm.fieldFocused || _vm.notEmpty(_vm.fieldCurValue),
        'textarea': _vm.Field.type === 'textarea',
        'short': _vm.Field._is_short === true,
        'readonly': _vm.Field.readonly === true,
        'field-in-modal': _vm.fieldInModal,
        'search-in-modal': _vm.fieldInModal && _vm.Field && _vm.Field._field_name === 'fastSearch',
        'for-captcha': _vm.Field.type === 'captcha'
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Field.title))), (_vm.Field.required === true) ? _c('span', {
    staticClass: "required-field"
  }, [_vm._v(" *")]) : _vm._e()]), _vm._v(" "), (_vm.Field.type === 'hidden') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    attrs: {
      "type": "hidden",
      "name": _vm.Field._field_name
    },
    domProps: {
      "value": (_vm.fieldCurValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldCurValue = $event.target.value
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'clearText') ? _c('span', {
    staticClass: "shown-text"
  }, [(_vm.Field.__subtype === 'rackdevice-from') ? _c('div', {
    staticClass: "lamp",
    class: {
      active: _vm.Field.__isPortActive
    }
  }) : _vm._e(), _vm._v("\n\t\t" + _vm._s(_vm.fieldCurValue) + "\n\t")]) : _vm._e(), _vm._v(" "), (_vm.Field.type === 'text') ? [(_vm.crud === 'dns-records' && _vm.Field['_field_name'] === 'host' && !_vm.Field.readonly) ? [_c('domainInput', {
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError, 'with-submit-button': _vm.needButtonSubmit === true
    },
    attrs: {
      "name": _vm.Field._field_name,
      "placeholder": "",
      "fixed": _vm.dnsFixedValue
    },
    on: {
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydownEnter": _vm.enterKeyDown
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    staticClass: "text-field",
    class: {
      'haserror': _vm.fieldError, 'paddingWithButton': _vm.clearButton, 'bitbtn-in-field': _vm.bigButton
    },
    attrs: {
      "type": "text",
      "name": _vm.Field._field_name,
      "autocomplete": _vm.Field._field_name === 'fastSearch' ? 'off' : null,
      "readonly": _vm.Field._field_name === 'fastSearch',
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "autofocus": _vm.Field._field_name === 'code' && _vm.crud === 'twofa'
    },
    domProps: {
      "value": (_vm.fieldCurValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldCurValue = $event.target.value
      }, _vm.onChange],
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    }
  })], _vm._v(" "), (_vm.clearButton) ? _c('div', {
    staticClass: "field-button-wrapper",
    class: {
      'bitbtn-in-field': _vm.bigButton, 'search-in-modal': _vm.fieldInModal && _vm.Field && _vm.Field._field_name === 'fastSearch'
    },
    on: {
      "click": _vm.clearButtonClick
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "times"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.searchButton) ? _c('div', {
    staticClass: "field-button-wrapper",
    on: {
      "click": _vm.searchButtonClick
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "search"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bigButton) ? _c('span', {
    staticClass: "btn btn-submit bitbtn-in-field",
    on: {
      "click": _vm.enterKeyDown
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.bigButtonTitle)))]) : _vm._e(), _vm._v(" "), ((_vm.crud === 'ticket' && _vm.action === 'create') || (_vm.crud === 'qa' && _vm.action === 'list')) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.qaResult),
      expression: "qaResult"
    }],
    staticClass: "w5-field-qa-result"
  }, [_c('strong', [_vm._v("В нашем QA есть похожие вопросы")]), _vm._v(": "), _c('br'), _vm._v(" "), _c('ul', _vm._l((_vm.qaResult), function(qa, indx) {
    return _c('li', {
      key: 'qa-item-' + indx
    }, [_c('a', {
      attrs: {
        "href": _vm.QAURL + '/q/' + qa.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(qa.cap) + " (" + _vm._s(qa.ans) + ")")])])
  }), 0)]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'captcha') ? _c('div', {
    staticClass: "captcha-block"
  }, [_c('div', {
    staticClass: "captcha-block-image",
    on: {
      "click": _vm.onCaptchaClick
    }
  }, [(_vm.Field.image) ? _c('img', {
    attrs: {
      "src": _vm.captchaUrl
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    staticClass: "text-field",
    class: {
      'haserror': _vm.fieldError, 'paddingWithButton': _vm.clearButton, 'bitbtn-in-field': _vm.bigButton
    },
    attrs: {
      "type": "text",
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "autofocus": _vm.Field._field_name === 'code' && _vm.crud === 'twofa'
    },
    domProps: {
      "value": (_vm.fieldCurValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldCurValue = $event.target.value
      }, _vm.onChange],
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.Field.type === 'money') ? [_c('numberInput', {
    ref: _vm.Field._field_name,
    staticClass: "paddingWithButton",
    class: {
      'haserror': _vm.fieldError, 'with-submit-button': _vm.needButtonSubmit === true
    },
    attrs: {
      "name": _vm.Field._field_name,
      "type": _vm.Field.type,
      "crud": _vm.crud,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false
    },
    on: {
      "animation": _vm.animationRequested,
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydownEnter": _vm.enterKeyDown
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }), _vm._v(" "), (_vm.Field.for) ? _c('div', {
    staticClass: "field-postfix-wrapper",
    class: {
      'with-top-hint': _vm.topHint
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc(_vm.Field.for))
    }
  })]) : _c('div', {
    staticClass: "field-postfix-wrapper",
    class: {
      'with-top-hint': _vm.topHint
    },
    style: (_vm.needButtonSubmit === true ? 'right: 76px !important' : false)
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'integer') ? [_c('numberInput', {
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError, 'paddingWithButton': _vm.Field.for
    },
    attrs: {
      "name": _vm.Field._field_name,
      "type": _vm.Field.type,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "needReact": _vm.needReact
    },
    on: {
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydownEnter": _vm.enterKeyDown
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }), _vm._v(" "), (_vm.Field.for) ? _c('div', {
    staticClass: "field-postfix-wrapper"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc(_vm.Field.for))
    }
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'float') ? [_c('numberInput', {
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError, 'paddingWithButton': _vm.Field.for
    },
    attrs: {
      "name": _vm.Field._field_name,
      "type": _vm.Field.type,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false
    },
    on: {
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydownEnter": _vm.enterKeyDown
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }), _vm._v(" "), (_vm.Field.for) ? _c('div', {
    staticClass: "field-postfix-wrapper"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc(_vm.Field.for))
    }
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'radio') ? [_c('radioListComponent', {
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "title": _vm.Field.title,
      "required": _vm.Field.required,
      "items": _vm.filterActiveList(_vm.Field.list),
      "placeholder": ""
    },
    on: {
      "input": _vm.onChange
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'list' && !_vm.isUniqueInVds() && !_vm.isUniqueInOperation() && !_vm.isUniqueInCertificate() && !_vm.isUniqueInDomains()) ? [(_vm.Field.multiselect === true) ? [(_vm.crud === 'user' && _vm.Field['_field_name'] === 'role_items') ? _c('userRole', {
    ref: _vm.Field['_field_name'],
    attrs: {
      "title": _vm.Field['title'],
      "name": _vm.Field['_field_name'],
      "master": _vm.Field['list_description'],
      "slave": _vm.Field['list']
    },
    on: {
      "focus": _vm.fieldFocus,
      "input": _vm.onSelectUserRole
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }) : (_vm.Field.url && _vm.Field['_field_name'] !== 'plans' && _vm.Field['_field_name'] !== 'templates') ? _c('multiselect', {
    ref: _vm.Field._field_name,
    staticClass: "w5-multiselecting w5-selecting-by-url",
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "placeholder": "",
      "label": "name",
      "options": _vm.curList,
      "showLabels": false,
      "allowEmpty": true,
      "searchable": true,
      "multiple": true,
      "track-by": "id",
      "disabled": _vm.Field.readonly === true,
      "internalSearch": false,
      "showNoOptions": false
    },
    on: {
      "input": _vm.onSelect,
      "open": _vm.onListOpen,
      "close": _vm.onListClose,
      "search-change": _vm.asyncListFind
    },
    model: {
      value: (_vm.listValue),
      callback: function($$v) {
        _vm.listValue = $$v
      },
      expression: "listValue"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusListRequestProcess.trim().length),
      expression: "statusListRequestProcess.trim().length"
    }],
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "slot": "beforeList"
    },
    slot: "beforeList"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.statusListRequestProcess)))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusListRequestResult.trim().length),
      expression: "statusListRequestResult.trim().length"
    }],
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.statusListRequestResult)))])]) : _c('multiselect', {
    ref: _vm.Field._field_name,
    staticClass: "w5-multiselecting w5-selecting-by-static",
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "placeholder": "",
      "label": "name",
      "options": _vm.curList,
      "showLabels": false,
      "allowEmpty": true,
      "searchable": false,
      "multiple": true,
      "track-by": "id",
      "disabled": _vm.Field.readonly === true ? true : false,
      "showNoOptions": false
    },
    on: {
      "input": _vm.onSelect,
      "open": _vm.onListOpen,
      "close": _vm.onListClose
    },
    scopedSlots: _vm._u([{
      key: "tag",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag",
          class: {
            'multiselect__option--notactive-tag': props.option.active === false || props.option.archive === true
          }
        }, [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.scopedGetOptionLabel(props.option))
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "multiselect__tag-icon",
          attrs: {
            "aria-hidden": "true",
            "tabindex": "1"
          },
          on: {
            "keydown": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              $event.preventDefault();
              return _vm.scopedRemoveElement(props.option)
            },
            "mousedown": function($event) {
              $event.preventDefault();
              return _vm.scopedRemoveElement(props.option)
            }
          }
        })])]
      }
    }], null, false, 422227897),
    model: {
      value: (_vm.listValue),
      callback: function($$v) {
        _vm.listValue = $$v
      },
      expression: "listValue"
    }
  })] : [(_vm.Field.url && (_vm.Field._field_name !== 'sshkey_id' && _vm.Field._field_name !== 'person_id' && _vm.Field._field_name !== 'operation_id')) ? _c('multiselect', {
    ref: _vm.Field._field_name,
    staticClass: "w5-singleselecting w5-selecting-by-url",
    class: {
      'haserror': _vm.fieldError, 'short-list': _vm.Field._is_short === true
    },
    attrs: {
      "placeholder": "",
      "label": "name",
      "options": _vm.isUrlWithQuery ? _vm.curList : _vm.preparedStaticList(_vm.curList),
      "showLabels": false,
      "allowEmpty": false,
      "searchable": _vm.isSelectSearchable,
      "disabled": _vm.Field.readonly === true ? true : false,
      "internalSearch": false,
      "showNoOptions": false,
      "track-by": "id"
    },
    on: {
      "input": _vm.onSelect,
      "open": _vm.onListOpen,
      "close": _vm.onListClose,
      "search-change": function (str) { return _vm.isUrlWithQuery ? _vm.asyncListFind(str) : _vm.mySearchFunction(str); }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(_vm.Field._field_name === 'server_id' && props.option.type) ? _c('span', {
          class: 'color-type-' + String(props.option.type),
          staticStyle: {
            "font-size": "13px"
          }
        }, [_vm._v("●")]) : _vm._e(), _vm._v("\n\t\t\t\t\t" + _vm._s(props.option.name) + "\n\t\t\t\t")]
      }
    }], null, false, 3738823343),
    model: {
      value: (_vm.listValue),
      callback: function($$v) {
        _vm.listValue = $$v
      },
      expression: "listValue"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusListRequestProcess.trim().length),
      expression: "statusListRequestProcess.trim().length"
    }],
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "slot": "beforeList"
    },
    slot: "beforeList"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.statusListRequestProcess)))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusListRequestResult.trim().length),
      expression: "statusListRequestResult.trim().length"
    }],
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.statusListRequestResult)))])]) : _c('multiselect', {
    ref: _vm.Field._field_name,
    staticClass: "w5-singleselecting",
    class: {
      'haserror': _vm.fieldError,
      'short-list': _vm.Field._is_short === true,
        'domains-person-with-button': _vm.crud === 'domains' && _vm.Field['_field_name'] === 'person_id'
    },
    attrs: {
      "placeholder": "",
      "label": "name",
      "options": _vm.preparedStaticList(_vm.curList),
      "showLabels": false,
      "allowEmpty": false,
      "searchable": _vm.curList.length > 15 && _vm.crud !== 'backupschedule',
      "internalSearch": false,
      "maxHeight": _vm.$store.state.windowWidth <= 767 ? 200 : 300,
      "track-by": "id",
      "disabled": _vm.Field.readonly === true ? true : false,
      "showNoOptions": false
    },
    on: {
      "search-change": _vm.mySearchFunction,
      "input": _vm.onSelect,
      "open": _vm.onListOpen,
      "close": _vm.onListClose
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [((_vm.crud === 'certificate' || _vm.crud === 'datacenter' || _vm.crud === 'person') && _vm.Field._field_name.indexOf('country') > -1) ? [_c('span', {
          staticClass: "flag-icon",
          class: 'flag-icon-' + props.option.id.toLowerCase(),
          staticStyle: {
            "margin-right": "10px",
            "top": "-1px"
          }
        }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(props.option.name) + "\n\t\t\t\t\t")] : (_vm.crud === 'backupDialog' && _vm.Field._field_name === 'service_id') ? [_c('div', {
          staticClass: "backup-dialog-service-option"
        }, [(props.option.template && props.option.template.image) ? _c('img', {
          attrs: {
            "src": _vm.APIServerUrl + props.option.template.image
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "plan"
        }, [_c('div', [_c('span', {
          staticClass: "flag-icon",
          class: 'flag-icon-' + props.option.datacenter.country.toLowerCase()
        }), _vm._v(" "), _c('span', {
          class: {
            not: !props.option.active
          }
        }, [_vm._v(_vm._s(props.option.name))])]), _vm._v(" "), (props.option.plan && props.option.plan.data) ? _c('div', [_c('span', {
          staticClass: "plan-info"
        }, [_vm._v(_vm._s(_vm.getPlanInfo(props.option.plan.data)))])]) : _vm._e()])])] : [(_vm.Field._field_name === 'migrateModalServerValue' && props.option.type) ? _c('span', {
          class: 'color-type-' + String(props.option.type),
          staticStyle: {
            "font-size": "13px"
          }
        }, [_vm._v("●")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t" + _vm._s(props.option.name) + "\n\t\t\t\t\t")]]
      }
    }], null, false, 1016398154),
    model: {
      value: (_vm.listValue),
      callback: function($$v) {
        _vm.listValue = $$v
      },
      expression: "listValue"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/search_not_found')))])])]] : _vm._e(), _vm._v(" "), (_vm.Field._field_name === 'plan_group_id' && _vm.crud === 'vds' && _vm.action === 'create') ? [_c('groupPlanComponent', {
    attrs: {
      "action": _vm.action,
      "groups": _vm.filterActiveList(_vm.Field['list'])
    },
    on: {
      "focus": _vm.emitFocus,
      "groupChanged": _vm.onGroupChanged
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field._field_name === 'plan_id' && _vm.crud === 'vds') ? [_c('planComponent', {
    attrs: {
      "items": _vm.filterActiveList(_vm.Field.list),
      "action": _vm.action,
      "groups": _vm.groupField && _vm.groupField['list'] ? _vm.groupField['list'] : null,
      "groupValue": _vm.groupField && _vm.groupField['value'] ? _vm.groupField['value'] : null,
      "cookieValue": _vm.Field && _vm.Field.cookieValue ? _vm.Field.cookieValue : null,
      "templateField": _vm.templateField,
      "ipInfo": _vm.ipInfo ? _vm.ipInfo : null
    },
    on: {
      "focus": _vm.emitFocus,
      "startData": _vm.onStartData,
      "groupChanged": _vm.onGroupChanged,
      "input": _vm.onChange,
      "params": _vm.onParams
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field._field_name === 'template_id' && _vm.crud === 'vds') ? _c('templateImageComponent', {
    attrs: {
      "action": _vm.action,
      "formFields": _vm.formFields,
      "planField": _vm.planField,
      "cookieValue": _vm.Field && _vm.Field.cookieValue ? _vm.Field.cookieValue : null,
      "dc": _vm.dc
    },
    on: {
      "focus": _vm.emitFocus,
      "startData": _vm.onStartData,
      "templateTab": _vm.onTemplateTab,
      "templateInput": _vm.onTemplateInput,
      "backupList": _vm.onBackupList
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Field._field_name === 'datacenter_id' && (_vm.crud === 'vds' || _vm.crud === 'disks')) ? [_c('countryComponent', {
    attrs: {
      "items": _vm.filterListForDataCenterInVds(_vm.Field.list),
      "crud": _vm.crud,
      "action": _vm.action,
      "readonly": _vm.Field.readonly
    },
    on: {
      "focus": _vm.emitFocus,
      "startData": _vm.onStartData,
      "input": _vm.onChange
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field._field_name === 'backup_id' && _vm.crud === 'disks') ? [_c('backupComponent', {
    attrs: {
      "action": _vm.action,
      "list": _vm.Field && _vm.Field.list && _vm.Field.list.length ? _vm.Field.list : [],
      "readonly": _vm.Field.readonly
    },
    on: {
      "focus": _vm.emitFocus,
      "input": _vm.onChange
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.isUniqueInCertificate()) ? [_c('planSslComponent', {
    attrs: {
      "title": _vm.Field.title,
      "required": _vm.Field.required,
      "items": _vm.filterActiveList(_vm.Field.list),
      "groups": _vm.groupField && _vm.groupField['list'] ? _vm.groupField['list'] : null,
      "groupValue": _vm.groupField && _vm.groupField['value'] ? _vm.groupField['value'] : null,
      "cookieValue": _vm.Field && _vm.Field.cookieValue ? _vm.Field.cookieValue : null
    },
    on: {
      "focus": _vm.emitFocus,
      "startData": _vm.onStartData,
      "groupChanged": _vm.onGroupChanged,
      "input": _vm.onChange
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.isUniqueInDomains()) ? [_c('planDomainComponent', {
    attrs: {
      "Field": _vm.Field,
      "items": _vm.filterActiveList(_vm.Field.list),
      "nameField": _vm.nameField,
      "actionField": _vm.actionField
    },
    on: {
      "focus": _vm.emitFocus,
      "blur": _vm.emitBlure,
      "onDomainName": _vm.onDomainName,
      "keydownEnter": _vm.enterKeyDown,
      "startData": _vm.onStartData,
      "input": _vm.onChange
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.isUniqueInOperation()) ? [_c('paymentComponent', {
    attrs: {
      "items": _vm.Field.list,
      "title": _vm.Field.title
    },
    on: {
      "focus": _vm.emitFocus,
      "input": _vm.onChange,
      "operationNextStep": _vm.onClientOperationNextStep
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'password') ? [((_vm.passwordIsShown ? 'text' : 'password') === 'checkbox' && (_vm.Field.generator)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    staticClass: "paddingWithButton eye",
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "autocomplete": "nope",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.fieldCurValue) ? _vm._i(_vm.fieldCurValue, null) > -1 : (_vm.fieldCurValue)
    },
    on: {
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      },
      "change": function($event) {
        var $$a = _vm.fieldCurValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.fieldCurValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.fieldCurValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.fieldCurValue = $$c
        }
      }
    }
  }) : ((_vm.passwordIsShown ? 'text' : 'password') === 'radio' && (_vm.Field.generator)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    staticClass: "paddingWithButton eye",
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "autocomplete": "nope",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.fieldCurValue, null)
    },
    on: {
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      },
      "change": function($event) {
        _vm.fieldCurValue = null
      }
    }
  }) : (_vm.Field.generator) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    staticClass: "paddingWithButton eye",
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "autocomplete": "nope",
      "type": _vm.passwordIsShown ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.fieldCurValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldCurValue = $event.target.value
      }, _vm.onChange],
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "type": "password",
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.fieldCurValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldCurValue = $event.target.value
      }, _vm.onChange],
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    }
  }), _vm._v(" "), (_vm.Field.generator) ? _c('div', {
    staticClass: "field-button-wrapper field-button-password-wrapper eye",
    class: {
      'in-modal': _vm.fieldInModal, 'slash': _vm.passwordIsShown
    },
    attrs: {
      "title": _vm._f("ftc")(((_vm.passwordIsShown ? 'main/hide' : 'main/show') + " main/password"))
    },
    on: {
      "click": _vm.togglePasswordVisibility
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": _vm.passwordIsShown ? 'eye-slash' : 'eye'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.Field.generator) ? _c('div', {
    staticClass: "field-button-wrapper field-button-password-wrapper",
    class: {
      'in-modal': _vm.fieldInModal
    },
    attrs: {
      "title": _vm._f("ftc")('main/password_generation')
    },
    on: {
      "click": _vm.generatePasswordHandler
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "random"
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'email') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "type": "email",
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "autocomplete": "nope"
    },
    domProps: {
      "value": (_vm.fieldCurValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldCurValue = $event.target.value
      }, _vm.onChange],
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'textarea') ? [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    style: (_vm.textAreaStyle()),
    attrs: {
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false
    },
    domProps: {
      "value": (_vm.fieldCurValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldCurValue = $event.target.value
      }, _vm.onChange],
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur
    }
  }), _vm._v(" "), (_vm.$store.state.user_type === 'admin' && (_vm.crud === 'ticketmessage' || _vm.crud === 'ticket') && _vm.action === 'create') ? _c('font-awesome-icon', {
    staticClass: "ticket-answer-template-btn",
    attrs: {
      "icon": "list-alt",
      "title": _vm._f("ftc")('mails/templates')
    },
    on: {
      "click": _vm.templateDialog
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'slider') ? [(_vm.crud === 'disks' && _vm.action === 'create' && _vm.Field._field_name === 'quantity') ? _c('OuterDiskType', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "-10px"
    },
    attrs: {
      "value": _vm.diskTypeValue
    },
    on: {
      "input": _vm.onOuterDiskTypeChanged
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "graph-slider-wrapper",
    class: _vm.action
  }, [_c('div', {
    staticClass: "input-text-slider",
    staticStyle: {
      "width": "110px"
    }
  }, [_c('div', {
    staticClass: "input-text-slider-field-wrapper"
  }, [_c('div', {
    staticClass: "input-slider-field-placeholder"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Field.title))), (_vm.Field.required) ? _c('span', {
    staticClass: "required-field"
  }, [_vm._v(" *")]) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: 'field-' + _vm.Field._field_name,
    staticClass: "input-slider-field",
    attrs: {
      "type": "text",
      "disabled": _vm.Field.readonly === true ? 'disabled' : false
    },
    domProps: {
      "value": _vm.outerDiskValue
    },
    on: {
      "blur": _vm.onSliderFieldBlurNew
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-slider-field-postfix"
  }, [_c('span', [_vm._v(_vm._s(_vm.Field.for))])])]), _vm._v(" "), (_vm.outerDiskError) ? _c('div', {
    staticClass: "input-slider-field-error"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.outerDiskError)) + "\n\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "graph-slider",
    staticStyle: {
      "width": "calc(100% - 160px)"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.outerDisksPriceDiscount) ? _c('span', {
    staticClass: "price-with-discount pull-right"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('servicetype/cost')) + ": "), _c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(_vm.outerDisksPriceDiscount)))]), _vm._v(" " + _vm._s(_vm._f("moneyOnlyNumbers")(_vm.outerDisksPrice)) + "\n\t\t\t\t\t\t"), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  }), _vm._v(" / " + _vm._s(_vm._f("ftc")(_vm.Field.period)) + "\n\t\t\t\t\t")]) : ('cost' in _vm.Field && 'period' in _vm.Field) ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('servicetype/cost')) + ": "), _c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(_vm.outerDisksPrice)) + "\n\t\t\t\t\t\t"), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  }), _vm._v(" / " + _vm._s(_vm._f("ftc")(_vm.Field.period)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('vue-slider', {
    ref: _vm.Field._field_name,
    attrs: {
      "min": 0,
      "max": 'max' in _vm.Field ? _vm.Field.max : 1,
      "duration": 0.2,
      "marks": _vm.sliderMarks,
      "interval": 'step' in _vm.Field ? _vm.Field.step : 1,
      "silent": true,
      "disabled": _vm.Field.readonly === true ? 'disabled' : false,
      "labelStyle": {
        fontSize: '10px',
        fontWeight: 300,
        color: '#666',
        top: '2px'
      },
      "tooltip": "none"
    },
    on: {
      "drag-start": function($event) {
        return _vm.$emit('dragStart')
      },
      "drag-end": function($event) {
        return _vm.$emit('dragEnd')
      },
      "change": _vm.onChange
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }, [_c('div', {
    staticClass: "process-minimum",
    style: (_vm.minRangeWidthStyle)
  })])], 1)])])] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'datetime') ? _c('DateTime', {
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "name": _vm.Field._field_name,
      "placeholder": "",
      "disabled": _vm.Field.readonly === true
    },
    on: {
      "input": _vm.datetimeInput
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Field.type === 'date') ? [(_vm.crud === 'person' && (_vm.Field._field_name === 'data[ru_phis][birth_date]' || _vm.Field._field_name === 'data[birth_date]')) ? _c('manualDateComponent', {
    key: _vm.Field._field_name,
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "required": _vm.Field.required,
      "disabled": _vm.Field.readonly === true ? 'disabled' : false
    },
    on: {
      "error": _vm.onError,
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }) : _c('datepicker', {
    key: _vm.Field._field_name,
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "name": _vm.Field._field_name,
      "id": _vm.Field._field_name,
      "placeholder": "",
      "disabled-picker": _vm.Field.readonly === true ? 'disabled' : false,
      "format": "dd.MM.yyyy",
      "language": _vm.$store.state.lang === 'en' ? 'en' : 'ru',
      "wrapper-class": "w5-field-date-wrapper",
      "input-class": "w5-field-date-input",
      "typeable": true,
      "monday-first": true,
      "clear-button": true
    },
    on: {
      "opened": _vm.onDateOpen,
      "closed": _vm.onDateClose,
      "selected": _vm.onDateSelect
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'passport') ? _c('passportComponent', {
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "name": _vm.Field._field_name,
      "required": _vm.Field.required,
      "readonly": _vm.Field.readonly,
      "errorMessage": _vm.Field._errMsg
    },
    on: {
      "error": _vm.onError,
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "enterKeyDown": _vm.enterKeyDown
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Field.type === 'phone') ? _c('phoneComponent', {
    key: _vm.Field._field_name,
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "required": _vm.Field.required,
      "disabled": _vm.Field.readonly === true ? 'disabled' : false
    },
    on: {
      "error": _vm.onError,
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Field.type === 'address') ? _c('addressComponent', {
    ref: _vm.Field._field_name,
    class: {
      'haserror': _vm.fieldError
    },
    attrs: {
      "name": _vm.Field._field_name,
      "title": _vm.Field.title,
      "validator": _vm.Field.validator,
      "required": _vm.Field.required,
      "readonly": _vm.Field.readonly,
      "errorMessage": _vm.Field._errMsg,
      "crud": _vm.crud
    },
    on: {
      "copyAddress": _vm.copyAddress,
      "error": _vm.onError,
      "input": _vm.onChange,
      "focus": _vm.fieldFocus,
      "blur": _vm.fieldBlur,
      "enterKeyDown": _vm.enterKeyDown
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Field.type === 'boolean') ? _c('div', {
    staticClass: "w5-boolean-field-wrapper",
    class: {
      'outer-disks-update': _vm.crud === 'disks' && _vm.action === 'update'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldCurValue),
      expression: "fieldCurValue"
    }],
    staticClass: "w5-checkbox-field",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox",
      "name": _vm.Field._field_name
    },
    domProps: {
      "checked": Array.isArray(_vm.fieldCurValue) ? _vm._i(_vm.fieldCurValue, null) > -1 : (_vm.fieldCurValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.fieldCurValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.fieldCurValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.fieldCurValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.fieldCurValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "w5-boolean-label",
    on: {
      "click": _vm.clickBooleanLabel
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Field.title)) + "\n\t\t\t\t"), ((_vm.crud === 'vds' || _vm.crud === 'disks') && _vm.action === 'create' && _vm.Field._field_name === 'backup_auto') ? [(_vm.BackupItemCost) ? _c('span', {
    staticClass: "backup-item-cost"
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v("→")]), _vm._v(" "), _c('span', {
    staticClass: "visible-xs",
    staticStyle: {
      "margin": "5px"
    }
  }, [_vm._v("↓")])]) : _vm._e(), _vm._v(" "), (_vm.isBackupItemDiscountCost) ? _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.BackupItemDiscountCost),
      expression: "BackupItemDiscountCost"
    }],
    staticClass: "price-with-discount"
  }) : _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.BackupItemCost),
      expression: "BackupItemCost"
    }]
  })] : _vm._e(), _vm._v(" "), (_vm.crud === 'domains' && _vm.action === 'update' && _vm.Field._field_name === 'privacy_set' && _vm.Field.period && 'cost' in _vm.Field) ? [_vm._m(0), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.BooleanFieldCost),
      expression: "BooleanFieldCost"
    }]
  })] : _vm._e(), _vm._v(" "), (_vm.Field.hint) ? [(_vm.crud === 'vds' && _vm.action === 'create' && _vm.Field._field_name === 'options') ? _c('span', {
    staticClass: "w5-boolean-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Field.hint)))]) : (_vm.crud === 'disks' && _vm.action === 'update' && _vm.Field._field_name === 'autoprolong') ? _c('span') : (_vm.fieldCurValue === true) ? _c('span', {
    staticClass: "w5-boolean-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Field.hint)))]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (_vm.crud === 'disks' && _vm.action === 'update' && _vm.Field._field_name === 'autoprolong') ? _c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/autoprolong_off')),
      expression: "localeFtc('service/autoprolong_off')"
    }],
    staticClass: "outer-disks-hint"
  }) : _vm._e(), _vm._v(" "), (_vm.bigButton) ? _c('span', {
    staticClass: "btn btn-submit bitbtn-in-field not-text",
    class: {
      'disabled': _vm.bigButtonEnabled !== true
    },
    on: {
      "click": _vm.bigButtonHandlerFunc
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.bigButtonTitle)))]) : _vm._e(), _vm._v(" "), (_vm.Field.after_text && _vm.Field.after_url && _vm.$store.state.user_type === 'admin') ? _c('span', [_vm._v(" ")]) : _vm._e(), (_vm.Field.after_text && _vm.Field.after_url && _vm.$store.state.user_type === 'admin') ? _c('linkComponent', {
    staticClass: "link-by-boolean",
    attrs: {
      "url": _vm.generateAfterUrl,
      "text": _vm._f("ftc")('(' + _vm.Field.after_text + ')')
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.Field.type === 'image' || _vm.Field.type === 'file') ? [(_vm.crud === 'iso' && _vm.action === 'create') ? _c('directFileComponent', {
    ref: _vm.Field._field_name,
    attrs: {
      "name": _vm.Field._field_name,
      "title": _vm.Field.title,
      "accept": _vm.Field.accept,
      "maxsize": _vm.Field.maxsize,
      "maxcnt": _vm.Field.max ? _vm.Field.max : 1
    },
    on: {
      "input": _vm.onChange,
      "focus": function($event) {
        _vm.Field._errMsg = ''
      },
      "uploadCanceled": _vm.onIsoUploadCanceled,
      "uploadFinished": _vm.onIsoUploadFinished,
      "uploadError": _vm.onIsoUploadError
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  }) : _c('fileComponent', {
    ref: _vm.Field._field_name,
    attrs: {
      "crud": _vm.crud,
      "name": _vm.Field._field_name,
      "title": _vm.Field.title,
      "accept": _vm.Field.accept,
      "maxsize": _vm.Field.maxsize,
      "maxcnt": _vm.Field.max,
      "multiple": _vm.Field.multifile,
      "candel": _vm.Field._canDelete
    },
    on: {
      "input": _vm.onChange,
      "abortUpload": _vm.onChange,
      "uploadFinished": _vm.onUploadFinished,
      "blockFormButton": _vm.blockFormButton,
      "unblockFormButton": _vm.unblockFormButton,
      "deleteFileValue": _vm.deleteFileValue,
      "cropCoords": _vm.cropCoords
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'urlButton') ? [_c('urlButtonComponent', {
    ref: _vm.Field._field_name,
    attrs: {
      "crud": _vm.crud,
      "name": _vm.Field._field_name,
      "url": _vm.Field.urlLink,
      "text": _vm.Field.urlText
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'simpleButton') ? [_c('span', {
    ref: _vm.Field._field_name,
    staticClass: "url-button",
    attrs: {
      "crud": _vm.crud,
      "name": _vm.Field._field_name
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.Field.buttonFunction($event)
      }
    }
  }, [(_vm.crud === 'vds' && _vm.Field._field_name === 'sshkey_id') ? _c('font-awesome-icon', {
    staticStyle: {
      "font-size": "24px",
      "top": "3px"
    },
    attrs: {
      "icon": "plus-circle"
    }
  }) : _vm._e(), _vm._v("\n\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Field.buttonText)) + "\n\t\t")], 1)] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'savedPayments') ? [_c('savedPaymentsComponent', {
    attrs: {
      "crud": _vm.crud,
      "action": _vm.action,
      "title": _vm.Field.title,
      "required": _vm.Field.required,
      "items": _vm.Field.list,
      "readonly": _vm.Field.readonly
    },
    on: {
      "focus": _vm.fieldFocus,
      "input": _vm.onChange,
      "deleteSavedPayment": _vm.onDeleteSavedPayment,
      "operationNextStep": _vm.onClientOperationNextStep
    },
    model: {
      value: (_vm.fieldCurValue),
      callback: function($$v) {
        _vm.fieldCurValue = $$v
      },
      expression: "fieldCurValue"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.hint && _vm.Field.type !== 'boolean' && _vm.Field.type !== 'passport' && _vm.Field.type !== 'address') ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Field.hint && _vm.fieldFocused && !_vm.fieldError),
      expression: "Field.hint && fieldFocused && !fieldError"
    }],
    staticClass: "w5-tooltip-wrapper"
  }, [_c('span', {
    staticClass: "w5-tooltip"
  }, [_vm._v(_vm._s(_vm._f("ftc")((_vm.crud === 'person' ? 'person/pattern: ' : '') + _vm.Field.hint)))])])]) : _vm._e(), _vm._v(" "), (_vm.crud === 'domains' && _vm.Field['_field_name'] === 'person_id') ? [_c('urlButtonComponent', {
    staticClass: "domains-person-create-button",
    attrs: {
      "crud": _vm.crud,
      "name": _vm.Field._field_name,
      "url": "/person/create",
      "text": "Создать персону"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.Field.type === 'header') ? _c('div', {
    staticClass: "header"
  }, [(_vm.Field.number && !(_vm.crud === 'disks' && _vm.fieldInModal)) ? _c('span', {
    staticClass: "step"
  }, [_vm._v(_vm._s(_vm.Field.number))]) : _vm._e(), _vm._v("\n\t\t" + _vm._s(_vm._f("ftc")(_vm.Field.title)) + "\n\t")]) : _vm._e(), _vm._v(" "), (_vm.fontawesomeButton) ? _c('font-awesome-icon', {
    staticClass: "fontawesome-btn",
    class: _vm.fontawesomeButton,
    attrs: {
      "icon": _vm.fontawesomeButton
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return (function () { return _vm.$emit('fontawesomeButton', {
          button: _vm.fontawesomeButton,
          field: _vm.Field._field_name
        }); })($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isUniqueInDomains() && _vm.Field.type !== 'passport' && _vm.Field.type !== 'address') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldError),
      expression: "fieldError"
    }, {
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.fieldError)),
      expression: "localeFtc(fieldError)"
    }],
    staticClass: "alert alert-danger w5-alert-valid",
    class: {
      'domains-person-error-message': _vm.crud === 'domains' && _vm.Field['_field_name'] === 'person_id', 'url-btn': _vm.Field.type == 'urlButton'
    },
    attrs: {
      "role": "alert"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Field.warningList) ? _c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.Field.warningList)),
      expression: "localeFtc(Field.warningList)"
    }],
    staticClass: "alert alert-danger w5-alert-valid warning",
    attrs: {
      "role": "alert"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bottomHint) ? _c('div', {
    staticClass: "w5-field-bottom-hint"
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.bottomHint)),
      expression: "localeFtc(bottomHint)"
    }]
  })]) : _vm._e(), _vm._v(" "), (_vm.rightHint) ? _c('div', {
    staticClass: "w5-field-right-hint",
    class: 'count-' + _vm.countVisibleFieldsInRow
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.rightHint)),
      expression: "localeFtc(rightHint)"
    }]
  })]) : _vm._e(), _vm._v(" "), (_vm.insteadFieldHint) ? _c('div', {
    staticClass: "w5-field-instead-hint",
    class: {
      error: _vm.crud === 'paymentauto' && _vm.Field._field_name === 'saved_id' && (!_vm.Field.list || !_vm.Field.list.length)
    }
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.insteadFieldHint)),
      expression: "localeFtc(insteadFieldHint)"
    }]
  })]) : _vm._e(), _vm._v(" "), ((_vm.Field.type != 'text' && _vm.Field.type != 'boolean') && _vm.bigButton) ? [(_vm.Field.type == 'fake' || _vm.Field.value) ? _c('span', {
    staticClass: "btn btn-submit bitbtn-in-field not-text",
    class: {
      'disabled': _vm.bigButtonEnabled !== true
    },
    on: {
      "click": _vm.bigButtonHandlerFunc
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.bigButtonTitle)))]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.linkButton && _vm.linkButtonVisible && _vm.linkButtonUrl) ? [_c('router-link', {
    staticClass: "btn btn-submit bitbtn-in-field not-text green",
    attrs: {
      "to": _vm.linkButtonUrl
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.linkButtonTitle)))])] : _vm._e(), _vm._v(" "), (_vm.needButtonSubmit === true) ? [_c('button', {
    staticClass: "btn btn-submit btn-in-field",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSubmitButton
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "check"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.progress) ? [_c('span', {
    staticClass: "w5-field-progress"
  }, [_c('div', {
    staticClass: "indicator"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loading-hor16.gif"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t" + _vm._s(_vm.progress) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.onIsoUploadCanceled
    }
  }, [_c('font-awesome-icon', {
    staticStyle: {
      "font-size": "15px"
    },
    attrs: {
      "title": _vm._f("ftc")('main/cancel'),
      "icon": "times-circle"
    }
  })], 1)])] : _vm._e(), _vm._v(" "), (_vm.linkHint && _vm.linkHint.showIfField === _vm.Field._field_name && _vm.Field.type !== 'list') ? _c('div', {
    staticClass: "w5-info-link margin-top-5"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "link"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.linkHintHtml(_vm.linkHint)),
      expression: "linkHintHtml(linkHint)"
    }]
  }), _vm._v(" "), (_vm.linkHint.afterText) ? _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.linkHint.afterText)))]) : _vm._e()], 1) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "backup-item-cost"
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v("→")]), _c('span', {
    staticClass: "visible-xs",
    staticStyle: {
      "margin": "5px"
    }
  }, [_vm._v("↓")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dd73f47"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/formfield.vue
// module id = 443
// module chunks = 0